import { createPortal } from 'react-dom';
import { FaPencilAlt } from 'react-icons/fa';

/**
 * Edit FAB: fixed on top of the viewport only while edit mode is active (yellow).
 * Otherwise sits at the bottom of the scrollable phone layout.
 */
const TransferEditFab = ({ editTransfers, setEditTransfers }) => {
  const button = (
    <button
      type="button"
      className={`phone-edit-fab ${editTransfers ? 'phone-edit-fab--portal phone-edit-fab--active' : ''}`}
      onClick={() => setEditTransfers(!editTransfers)}
      aria-label={editTransfers ? 'Exit edit transfers' : 'Edit transfers'}
      aria-pressed={editTransfers}
      title={editTransfers ? 'Exit edit mode' : 'Edit transfers'}
    >
      <FaPencilAlt />
    </button>
  );

  if (editTransfers && typeof document !== 'undefined') {
    return createPortal(button, document.body);
  }

  return <div className="phone-edit-fab-wrap">{button}</div>;
};

export default TransferEditFab;
